export const GET_APP_INFO = "GET_APP_INFO";
export const GET_APP_INFO_FAILED = "GET_APP_INFO_FAILED";
export const GET_APP_INFO_SUCCESS = "GET_APP_INFO_SUCCESS";

// Currencies
export const GET_CURRENCIES = "GET_CURRENCIES";
export const GET_CURRENCIES_SUCCESS = "GET_CURRENCIES_SUCCESS";
export const GET_CURRENCIES_FAIL = "GET_CURRENCIES_FAIL";

// Cities
export const GET_CITIES = "GET_CITIES";
export const GET_CITIES_SUCCESS = "GET_CITIES_SUCCESS";
export const GET_CITIES_FAIL = "GET_CITIES_FAIL";

// Communication Channels
export const GET_COMM_CHANNELS = "GET_COMM_CHANNELS";
export const GET_COMM_CHANNELS_SUCCESS = "GET_COMM_CHANNELS_SUCCESS";
export const GET_COMM_CHANNELS_FAIL = "GET_COMM_CHANNELS_FAIL";

// Municipalities
export const GET_MUNICIPALITIES = "GET_MUNICIPALITIES";
export const GET_MUNICIPALITIES_SUCCESS = "GET_MUNICIPALITIES_SUCCESS";
export const GET_MUNICIPALITIES_FAIL = "GET_MUNICIPALITIES_FAIL";